// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"JobSmallImg_boxWrapper__3qxPF","img":"JobSmallImg_img__2LORy","textBox":"JobSmallImg_textBox__xDEi0","title":"JobSmallImg_title__1QW5B"};